import React from 'react';
import { useCurator } from '@noths/curator-web';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      m.configureCurator({
        env: isProd() ? 'production' : 'qa',
      });
      return m.Curator;
    }),
  { ssr: false },
);

interface CuratorWrapperProps {
  enableCurator?: boolean;
}

export const CuratorWrapper = ({ enableCurator }: CuratorWrapperProps) => {
  const showCurator = enableCurator ?? false;
  const { handleToggle, isCuratorOpen, redirectToPDP } = useCurator();

  if (!showCurator) {
    return null;
  }

  return (
    <Curator
      isOpen={isCuratorOpen}
      onProductClick={redirectToPDP}
      onToggle={handleToggle}
      showFavourties
    />
  );
};
